import styled from "@emotion/styled";
import { ellipsis } from "polished";
import * as React from "react";

import { Edit } from "@livechat/design-system-icons";
import { Button, DesignToken, Icon } from "@livechat/design-system-react-components";

import { ResponsiveBreakpoint } from "constants/responsive-breakpoint";
import { withVar } from "themes/helpers";

interface IProps {
  isFetching: boolean;
  subject: string | null;
  canEditSubject: boolean;
  onSubjectModalOpen(): void;
}

export const TicketTitle: React.FC<IProps> = ({ isFetching, subject, canEditSubject, onSubjectModalOpen }) => {
  if (isFetching) {
    return null;
  }

  return (
    <StyledTitle>
      <StyledSubject title={subject ?? undefined} className="fs-mask">
        {subject || <EmptySubject>No subject</EmptySubject>}
      </StyledSubject>
      {canEditSubject && (
        <IconWrapper data-testid="edit-subject">
          <Button
            kind="plain"
            size="compact"
            disabled={!canEditSubject}
            onClick={canEditSubject ? onSubjectModalOpen : undefined}
            icon={<Icon source={Edit} />}
          />
        </IconWrapper>
      )}
    </StyledTitle>
  );
};

const StyledTitle = styled.span`
  display: flex;
  align-items: center;
  margin-left: 52px;
  @media (max-width: ${ResponsiveBreakpoint.Mobile}px) {
    max-width: calc(100% - 100px);
  }
`;

const StyledSubject = styled.span`
  ${ellipsis()};
`;

const EmptySubject = styled.span`
  color: ${withVar(DesignToken.ContentBasicDisabled)};
`;

const IconWrapper = styled.span`
  display: flex;
  margin-left: 10px;
`;

export default React.memo(TicketTitle);
